import Environment from './models/environment.model';

import LiveAU from './configs/live.au';
import LiveCA from './configs/live.ca';
import LiveNL from './configs/live.nl';
import LiveUK from './configs/live.uk';
import LiveUS from './configs/live.us';

import TestAU from './configs/test.au';
import TestCA from './configs/test.ca';
import TestNL from './configs/test.nl';
import TestUK from './configs/test.uk';
import TestUS from './configs/test.us';

import DevAU from './configs/dev.au';

if (!_APP_LEAP_ENV_) {
  throw new Error('_APP_LEAP_ENV_ is not defined!');
}
// We need to define REACT_APP_LEAP_ENV!

const environmentMap: Record<string, Environment> = {
  'live.au': LiveAU,
  'live.ca': LiveCA,
  'live.uk': LiveUK,
  'live.us': LiveUS,
  'live.nl': LiveNL,

  'test.au': TestAU,
  'test.ca': TestCA,
  'test.uk': TestUK,
  'test.us': TestUS,
  'test.nl': TestNL,

  'dev.au': DevAU,
};
const developmentRegion = JSON.parse(localStorage.getItem('developmentRegion'));

const environment =
  process.env.NODE_ENV === 'development'
    ? environmentMap[developmentRegion || _APP_LEAP_ENV_]
    : environmentMap[_APP_LEAP_ENV_];

export const isLive =
  process.env.NODE_ENV !== 'development' && (environment.env === 'live' || environment.env === 'liveb');
const localeMap = {
  au: 'en-AU',
  ca: 'en-AU', // keep same behavior like AU
  us: 'en-US',
  uk: 'en-GB',
  nl: 'nl-NL',
};

let timeZone = environment.timezone;

export const getTimeZone = () => timeZone;
const updateTimeZone = (timezone) => {
  timeZone = timezone;
};

const region =
  process.env.NODE_ENV === 'development'
    ? (developmentRegion || _APP_LEAP_ENV_).split('.')?.[1]
    : _APP_LEAP_ENV_.split('.')?.[1];
export const locale = localeMap[region] || localeMap['au'];

export { environment, updateTimeZone };

export const EndOfMonthInstructions = {
  au: 'https://community.leap.com.au/s/article/End-of-month-reporting-for-trust-funds-AU',
  nz: 'https://help.leaplegalsoftware.co.nz/s/article/End-of-Month-Procedure-NZ',
  uk: 'https://community.leap.co.uk/s/article/End-of-month-reports-on-Client-Funds',
  ie: 'https://community.leapsoftware.ie/s/article/End-of-month-reports-on-Client-Funds-IE',
  us: 'https://community.leap.us/s/article/General-trust-end-of-month-report',
  ca: 'https://help.leaplegalsoftware.ca/s/article/End-of-Month-Procedure-CA',
}[region];
